/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.piesync.bridge.rpc.AppsRpc
 */
import * as References from './AppsRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.piesync.bridge.rpc.AppsRpc#getAll
 */
export const GET_ALL_QUERY_FIELD_NAME =
  'com_hubspot_piesync_bridge_rpc_AppsRpc_getAll';
export const GET_ALL_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetAllResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_ALL_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetAllResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.getAllRpc, {
      timeout: ctx.timeout,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.piesync.bridge.rpc.AppsRpc#getApp
 */
export const GET_APP_QUERY_FIELD_NAME =
  'com_hubspot_piesync_bridge_rpc_AppsRpc_getApp';
export const GET_APP_QUERY: RegisteredQuery<
  'result',
  References.GetAppRequestType,
  References.GetAppResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_APP_QUERY_FIELD_NAME,
  args: ['appId'],
  fetcher(
    request: References.GetAppRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetAppResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.getAppRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});
